const upper = str => {
  return str ? str.toUpperCase() : '';
};
/**
 * 将 schema 对象转为 emap 的 querySetting 格式
 */


export const parseSchema = (schema, parent) => {
  if (schema.type === 'op') {
    // schema type is 'op' or 'relation'
    // each op node should have a parent node
    const {
      name,
      value,
      builder
    } = schema;

    if (!value) {
      return null;
    }

    const ret = {
      name,
      value,
      builder
    };

    if (parent) {
      ret.linkOpt = upper(parent.builder);
    }

    return ret;
  } // relation node


  const {
    children = []
  } = schema;

  if (children.length === 0) {
    return null;
  }

  const collection = children.map(item => {
    const parsed = parseSchema(item, schema);
    return parsed;
  }).filter(item => !!item);
  return collection;
};